export const loginBaselineFa = {
  brand: 'اوچال',
  title: 'ورود به فضای کاری',
  description: 'برای دسترسی امن به سامانه، اطلاعات حساب سازمانی خود را وارد کنید.',
  identity: 'نام کاربری یا شماره همراه',
  password: 'رمز عبور',
  remember: 'مرا به خاطر بسپار',
  secure: 'ارتباط امن',
  submit: 'ورود به سامانه',
  help: 'برای دریافت یا بازیابی اطلاعات ورود با مدیر سامانه تماس بگیرید.',
  platform: 'پلتفرم سازمانی اوچال',
  copyright: '© ۱۴۰۵ اوچال',
  edition: 'نسخه سازمانی',
  company: 'فناوران اوچال صنعت تبرستان',
  slogan: 'اوچال، نمادی از کیفیت',
  overview: 'مرکز یکپارچه مدیریت عملیات، منابع و فرآیندهای سازمانی اوچال',
  fast: 'سریع و در دسترس',
  fastDescription: 'تجربه روان در دسکتاپ، تبلت و موبایل',
  modular: 'یکپارچه و ماژولار',
  modularDescription: 'دسترسی متمرکز به ابزارهای سازمانی',
  safe: 'امن و قابل اعتماد',
  safeDescription: 'کنترل دسترسی و حفاظت از نشست‌ها',
  ready: 'سامانه آماده خدمت‌رسانی است',
  infrastructure: 'زیرساخت امن و ماژولار',
} as const;
